 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		49: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"components/video-info","2":"default/components/comment-dialog-seo-index/components/video-swiper/pages/foryou/index/pages/video/_photoId","3":"swiperVendors","5":"components/video-swiper","6":"vendors/components/video-swiper/pages/foryou/index/pages/video/_photoId","7":"pages/user/components/list/index","8":"pages/user/components/user-profile-base-info/index","11":"components/add-to-home-screen","12":"components/add-to-home-screen-new","13":"components/comment-dialog","14":"components/comment-dialog-hooks-use-comment-dialog","15":"components/comment-dialog-seo-index","16":"components/empty","17":"components/header-nav","18":"components/header-tabs","19":"components/image-box","20":"components/loading-dark","21":"components/login","22":"components/new-empty","23":"components/new-open-kwai-notice","24":"components/share-panel","25":"components/video-action","26":"components/video-bottom-collection","27":"components/video-tag-warp","28":"pages/discover/_content","29":"pages/discover/components/card/index","30":"pages/discover/components/list/index","31":"pages/discover/components/search/index","32":"pages/discover/hooks/useVideoList","33":"pages/foryou/index","34":"pages/message/index","35":"pages/playlist/_albumId","36":"pages/playlist/components/card/index","37":"pages/playlist/components/list/index","38":"pages/playlist/hooks/useList","39":"pages/profile/index","40":"pages/user/_userId","41":"pages/user/components/collection-swipper/index","42":"pages/user/components/nav/index","43":"pages/user/components/post-card/index","44":"pages/user/components/user-profile-base-info/useProfileInfo","45":"pages/user/hooks/useInfo","46":"pages/user/hooks/useList","47":"pages/user/hooks/useNoticePopup","48":"pages/video/_photoId"}[chunkId]||chunkId) + "." + {"1":"e9f2240bd98b12f17b86","2":"d0b906f2a705d5da5237","3":"b71e16929c98e6a2c8c0","5":"b0ca3d2f2d3b7b1a8f07","6":"9d8fa39c20ba68b69cfe","7":"8bbb16b5fad0ce875bbe","8":"be01b5c031940dd6c56b","11":"bd8e47df5573bcd72a1a","12":"cde1ed03dc8ed735c416","13":"598a3ea7b5ce46276922","14":"9a5cde5d104a02ca817e","15":"75aafa7cb9b5ba3e589d","16":"f938dcb3ba4302cabde9","17":"fc16612ca26a30de2ec1","18":"cc7c0b4e9138814bcd2d","19":"aac2bd87b75fc1cda8fa","20":"915be48af620bb19cf09","21":"3d72ad8d061b10eda522","22":"a579730e2ae208bc3c5d","23":"69a96576ff1f07001759","24":"15b9879dd1047695a5ba","25":"5b760d794c3cbee2c535","26":"1127a993880845fca776","27":"3944cfefcff27cfd501d","28":"ded5fcabaf3e25fd5d7b","29":"d9cd11b8c6d0b6c06528","30":"3885cd1a534dd81161df","31":"f50dcc1eeaca0d4cbaf5","32":"dce18e1660937edfb94c","33":"49d00651f1772f71695d","34":"db06dd8d7caab06ef30c","35":"9511827214eb223eaacc","36":"46f6ae39a6fa5a659161","37":"b132eac64c525f7b0b55","38":"2a3aa4d3d7b3344a0080","39":"a8228a6a124676ea47c6","40":"968ca9e71eaf4a38e89a","41":"4e4ae1f0b664e1f826e5","42":"5ff7976e44061632f1f6","43":"d64f441088741df28d06","44":"fc5e93ea6e65948db484","45":"f775cc68bb366794f67a","46":"96b648c28a1a5fe46775","47":"1cde0312aa99ce201631","48":"c82a614f999639d0b2f3","53":"38cc9bd99a301689fef4","54":"01d6a9173091483c9fc7"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn-static.kwai.net/kos/s101/nlav11312/kwai-nuxt-pwa-online/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
